import { CircularProgress, Container, Stack, Typography } from '@mui/material';

export function PublicSignerLoadingState() {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 8, md: 14 } }}>
      <Stack
        alignItems="center"
        spacing={2}
        sx={(theme) => ({
          backgroundColor: 'background.paper',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '20px',
          p: { xs: 3, sm: 4 }
        })}
      >
        <CircularProgress />
        <Typography color="secondary.main" fontWeight={600} variant="h6">
          Opening signing session
        </Typography>
        <Typography
          align="center"
          color="var(--palette-semantic-text-secondary)"
          variant="body2"
        >
          Verifying your link and preparing the document.
        </Typography>
      </Stack>
    </Container>
  );
}
